import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { getUserProfile } from '../services/userService';
import Sidebar from './Sidebar';
import Logo from './Logo';
import ThemeToggle from './ThemeToggle';
import Icon from './Icon';

function NavBar({ title = 'Follow Up AI' }) {
  const { user } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [userProfile, setUserProfile] = useState(null);

  useEffect(() => {
    const loadProfile = async () => {
      if (user?.uid) {
        try {
          const profile = await getUserProfile(user.uid).catch(() => null);
          setUserProfile(profile);
        } catch (error) {
          console.warn('Could not load user profile:', error);
        }
      }
    };
    
    loadProfile();
  }, [user]);

  return (
    <>
      <nav className="sticky top-0 z-10 bg-white/80 dark:bg-zinc-900/80 backdrop-blur-sm border-b border-zinc-200 dark:border-zinc-800 transition-colors">
        <div className="max-w-md mx-auto px-4 py-3">
          <div className="flex items-center justify-between">
            <div className="flex-1 flex items-center justify-center gap-2">
              <Logo size="md" />
              <h1 className="text-xl font-bold bg-gradient-to-r from-zinc-900 to-zinc-600 dark:from-zinc-100 dark:to-zinc-400 bg-clip-text text-transparent">
                FollowUP
              </h1>
            </div>
            <div className="flex items-center gap-2">
              <ThemeToggle />
              <button
                onClick={() => setSidebarOpen(true)}
                className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-zinc-100 dark:bg-zinc-800 hover:bg-zinc-200 dark:hover:bg-zinc-700 transition-colors"
              >
                <div className="w-8 h-8 rounded-full bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center text-white font-bold text-sm">
                  {userProfile?.name ? userProfile.name.charAt(0).toUpperCase() : user?.email?.charAt(0).toUpperCase() || 'U'}
                </div>
                <span className="text-xs text-zinc-700 dark:text-zinc-300 font-medium hidden sm:inline">
                  {userProfile?.name || user?.displayName || 'Menu'}
                </span>
                <Icon emoji="☰" size="text-base" className="text-zinc-600 dark:text-zinc-400" />
              </button>
            </div>
          </div>
        </div>
      </nav>

      <Sidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        userProfile={userProfile}
      />
    </>
  );
}

export default NavBar;

